<app-layout>
    <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.networks')">Networks</inertia-link>
        - {{ subTitle }}
    </h1>
    <div class="bg-white rounded shadow overflow-hidden lg:w-1/2">
        <form @submit.prevent="submit">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                <div class="pr-6 pb-8 w-full">
                    <div class="font-weight-bold text-xl border-b mb-2 pb-4 font-medium">General Information</div>
                </div>

                <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label block mr-2 mb-3">Network Status</label>
                    <t-toggle v-model="form.status" />
                </div>

            </div>
            <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
                <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">{{ actionButtonTitle }}</loading-button>
            </div>
        </form>
    </div>
</app-layout>
